import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@env/environment';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class IndustrySectorsAndFeildsService {

  url:string=environment.domain;

  // fields:BehaviorSubject<any[]>=new BehaviorSubject([])

  constructor(private http:HttpClient){}

  // getIdustryFields(id:number){
  //   this.getIndustryFields(id).subscribe((res:any)=> this.fields.next(res.data))
  // }

  getIndustryFields(id:number):Observable<any[]>{
    return this.http.get<any[]>(`${this.url}IndustrySectorField/GetAllIndustrySectorFields/${id}`)
  }

  getIndustryFieldByID(id:number):Observable<any[]>{
    return this.http.get<any[]>(`${this.url}IndustrySectorField/GetIndustrySectorFiledById/${id}`)
  }

  postIndustrySectorFeild(data:any){
    return this.http.post(`${this.url}IndustrySectorField/CreateIndustrySectorFiled`,data)
  }

  updateIndustrySectorFeild(data:any){
    return this.http.put(`${this.url}IndustrySectorField/UpdateIndustrySectorFiled`,data)
  }

  deleteIndustrySectorFeild(id:number){
    return this.http.delete(`${this.url}IndustrySectorField/DeleteIndustrySectorFiled/${id}`)
  }
}
